import { create } from 'zustand'

export type SchoolInfo = {
  averageWeight?: number | null
  count?: number | null
  totalBiomass?: number | null
  density?: number | null
  feedingRate?: number | null
  moveDate?: number | null
  startDate?: Date | string | null
}

export type SchoolState = { [schoolId: string]: SchoolInfo }

type SchoolStore = {
  schools: SchoolState
  setSchools: (schools: SchoolState) => void
  addSchool: (schoolId: string, schoolInfo: SchoolInfo) => void
  updateSchool: (schoolId: string, schoolInfo: SchoolInfo) => void
  delSchool: (schoolId: string) => void
}

export const useSchoolStore = create<SchoolStore>((set) => ({
  schools: {},
  setSchools: (schools) => {
    set(() => ({ schools }))
  },
  addSchool: (schoolId, schoolInfo) => {
    set((state) => ({
      schools: {
        ...state.schools,
        [schoolId]: schoolInfo,
      },
    }))
  },
  updateSchool: (schoolId, schoolInfo) => {
    set((state) => ({
      schools: {
        ...state.schools,
        [schoolId]: schoolInfo,
      },
    }))
  },
  delSchool: (schoolId) => {
    set((state) => {
      const newSchools = { ...state.schools }
      delete newSchools[schoolId]
      return { schools: newSchools }
    })
  },
}))
